export default __webpack_public_path__ + "static/media/FOTOS_DISCO_02.57871d40.jpg";